export const quoteFormTabs = {
  contracts: "Contracts",
  quote: "Quote",
  freight: "Freight",
  charges: "Charges",
  layout: "Layout",
  email: "Email",
};
